<script lang="ts" setup>
  import type { Country } from '@storefront/types';
  import type { Dictionary } from '@othercommerce/domain';

  interface Props {
    countries: Country[];
    readonly: boolean;
    regions: Dictionary;
  }

  defineProps<Props>();
</script>

<template>
  <SfFormSelect :label="$t('SHOP.COMMON.LABEL.COUNTRY')" :options="countries" :readonly name="countryCode" required />
  <SfFormInput :label="$t('SHOP.COMMON.LABEL.FIRSTNAME')" name="firstName" required />
  <SfFormInput :label="$t('SHOP.COMMON.LABEL.LASTNAME')" name="lastName" required />
  <SfFormInput :label="$t('SHOP.COMMON.LABEL.EMAIL')" name="email" required />
  <SfFormInput :label="$t('SHOP.COMMON.LABEL.PHONE')" name="phone" />
  <SfAddressForm :readonly :regions billable external-country="countryCode" external-type="type" typed />
</template>
